/*
 * @Author: panweikang
 * @Date: 2025-02-19 15:52:22
 * @LastEditTime: 2025-03-05 21:34:54
 * @Description: 
 */

import React, { Component, useEffect, useState, useMemo } from "react";
import './index.scss'
import { connect } from 'react-redux';
import { Icon } from 'antd-mobile'

import logoPng from '../../images/mine/logo.png'
import ixuanzhilogoPng from '../../images/mine/ixuanzhilogo.png'
import qrcodePng from '../../images/mine/qrcode.png'
import {
  CloseCircleOutlined
} from '@ant-design/icons';
import { message } from "antd";
import Util from "../../utils/Utils";
const MFooter = ({ dispatch, router }) => {

  const [open, setOpen] = useState(false);
  const [showGoWx, setShowGoWx] = useState(false);

  useEffect(() => {
    if (Util.isWeChat()) {
      setShowGoWx(true)
    }
  }, [])

  const goFW = () => {
    window.location.href =
      'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjc4OTg2Mg==#wechat_redirect'
  }

  const goIXuanZhi = () => {
    console.log(window.__wxjs_environment)
    if (window.__wxjs_environment === 'miniprogram') {

      // todo 触发 postmessage

      console.log('在微信小程序中')
      window.wx.miniProgram.postMessage({
        data: {
          type: 'goIxuanzhiMiniProgram',
          value: 'xxx'
        }
      })
      window.wx.miniProgram.navigateBack();

    } else {
      message.info('请在微信环境中查看')
    }
  }

  const goVideo = () => {
    setOpen(true)
  }

  const closeFn = () => {
    setOpen(false)
  }
  return (
    <div className="Footer">
      <p className="FooterText1">更多物流地产最新资讯与独家干货</p>
      <div className="FooterText2">
        <span className="line"></span>
        <p>尽在瑞莱博产品与新媒体矩阵</p>
      </div>
      <Icon type="down" className="FooterIcon" />
      <div className="FooterLink" >
        {
          showGoWx ? <wx-open-launch-weapp
            id="launch-btn"
            appid="wx3a29dc00b4677290"
            path="modules/wms/views/zone/list/index"
          >
            <script type="text/wxtag-template">
              <div>
                <img src={ixuanzhilogoPng} />
                <p>选址小程序</p>
              </div>

            </script>
          </wx-open-launch-weapp>
            :
            <div onClick={goIXuanZhi}>
              <img src={ixuanzhilogoPng} />
              <p>选址小程序</p>
            </div>
        }

        <div onClick={goFW}>
          <img src={logoPng} />
          <p>微信服务号</p>
        </div>
        <div onClick={goVideo}>
          <img src={qrcodePng} />
          <p>扫码关注视频号</p>
        </div>
      </div>

      <p className="FooterCopyright">© {new Date().getFullYear()} 瑞莱博 RELIABLE. All rights reserved.</p>
      {
        open && <div className="videoImgWrap">
          <CloseCircleOutlined onClick={() => { closeFn() }} style={{ color: '#000' }} className='wrapPngClose' />
          <img src={qrcodePng} className="videoImg" />
        </div>
      }
    </div>

  );
};


function mapStateToProps(store) {
  return {};
}


export default connect(mapStateToProps)(MFooter);
